/**
 * Performance Plugin Landing Page
 */

import './performance-plugin.css';

// Import shared utilities
import '../shared/topbar.js';
import '../shared/coupon.js';
import '../shared/mobile-menu.js';

// Import landing page modules
import '../shared/landing/hero.js';
import '../shared/landing/animations.js';

// Import FAQ accordion
import '../shared/faq.js';

function downloadPlugin() {
  // Download ZIP file
  const link = document.createElement('a');
  link.href = 'https://pressidium.com/wp-content/uploads/2025/12/pressidium-performance.zip';
  link.download = '';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Scroll to the "How to install" section
  const target = document.querySelector('#how-to-install');
  if (target) {
    const offset = 120;
    const y = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  }
}

document.querySelector('#downloadButton').addEventListener('click', downloadPlugin);

console.log('Performance Plugin page loaded (Edge/Vite bundle)');
